var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35355 8.14645C1.15829 7.95118 0.841709 7.95118 0.646447 8.14645C0.451184 8.34171 0.451184 8.65829 0.646447 8.85355L1.35355 8.14645ZM3.5 11L3.14645 11.3536C3.34171 11.5488 3.65829 11.5488 3.85355 11.3536L3.5 11ZM6.35355 8.85355C6.54882 8.65829 6.54882 8.34171 6.35355 8.14645C6.15829 7.95118 5.84171 7.95118 5.64645 8.14645L6.35355 8.85355ZM0.646447 8.85355L3.14645 11.3536L3.85355 10.6464L1.35355 8.14645L0.646447 8.85355ZM3.85355 11.3536L6.35355 8.85355L5.64645 8.14645L3.14645 10.6464L3.85355 11.3536ZM4 11L4 -1.08372e-08L3 1.08372e-08L3 11L4 11Z",
    fill: "#B6B6B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.c48e7bec.svg";
export { ForwardRef as ReactComponent };